import React, { useEffect, useState } from 'react';

import { Spinner } from 'reactstrap';

import { CommonHelper, PSLHelper } from '@digitalworkflow/dwtranslateclient';
import { PSL } from '@digitalworkflow/psl_web';
import { store } from './redux/store';
import { Provider } from 'react-redux';

import App from './App';
import { ToastContainer } from 'react-toastify';

const AppInitialize = () => {
  const [isPSLIntialize, setIsPSLIntialize] = useState<boolean>(true);

  useEffect(() => {
    Initialization();
  }, []);

  const Initialization = async () => {
    setIsPSLIntialize(true);

    // Default's to the staging server which will work
    // for all environments unless a firewall blocks staging

    // if (process.env.REACT_APP_PSL_ENDPOINT)
    PSL.SetPSLEndpoint('https://translatedev.dw.protovate.com/api');

    const envName =
      process.env.REACT_APP_ENV || process.env.REACT_APP_PSL_ENV || '';
    console.log(
      'Initializing Dwbuilder with Environment: ',
      process.env.REACT_APP_PSL_ENV
    );

    PSL.SetProjectName('dw');
    PSL.SetEnvironment(envName);

    const envType = PSL.GetEnvironment();
    CommonHelper.setEnvironment(envType);

    await PSLHelper.initialize();
    setIsPSLIntialize(false);
  };

  return (
    <>
      {!isPSLIntialize ? (
        <Provider store={store}>
          <App />
          <ToastContainer
            containerId='main-toast'
            position='bottom-right'
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme='light'
          />
        </Provider>
      ) : (
        <div className='d-flex justify-content-center'>
          <Spinner style={{ height: '30px', width: '30px' }} />
        </div>
      )}
    </>
  );
};
export default AppInitialize;
